import { Model } from "@vuex-orm/core";
import Location from "./Location";
import WorkOrder from "./WorkOrder";
import {
  required,
  maxLength,
  decimal,
  minValue
} from "vuelidate/lib/validators";
import BatchRawOrigin from "./BatchRawOrigin";
import { BatchAttachment } from "./Attachment";
import { BatchMeasurement } from "./Measurement";
import { ShippingItem } from "./Shipping";

export default class Batch extends Model {
  static entity = 'batches';

  static $fetchActive() {
    return this.api().get('Batches/?archived=false')
  }
  static $fetchShipping() {
    return this.api().get('Batches/?ready_to_ship=true')
  }
  static $fetchAvailPico() {
    return this.api().get('Batches/?picoshield=true')
  }
  static $fetchAll() {
    return this.api().get('Batches/')
  }
  static $get (id) {
    return this.api().get(`Batches/${id}/`)
  }
  static $post (data) {
    return this.api().post(`Batches/`, data)
  }
  static $put (id, data) {
    return this.api().put(`Batches/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`Batches/${id}/`, data)
  }


  static fields() {
    return {
      id: this.attr(null),
      isBatch: this.boolean(true),
      forgeID: this.string("9999"),
      icon: this.string("fas fa-cube"),
      name: this.string(""),
      created: this.string(""),
      lastmodified: this.string(""),
      runnotes: this.string(""),
      coatedquantity: this.string(""),
      coatedquantityIcon: this.string("fas fa-weight"),
      coatedquantityColor: this.string("blue-grey darken-2"),
      coatedcycles: this.number(""),
      coatedcyclesIcon: this.string("fas fa-recycle"),
      coatedcyclesColor: this.string("blue-grey darken-2"),
      picoshield: this.boolean(false),
      archived: this.boolean(false),
      ready_to_ship: this.boolean(false),
      units: this.string("g"),
      parent: this.belongsTo(Batch, "parent_id"),
      parent_id: this.attr(null),
      project: this.number(""),
      children: this.hasMany(Batch, "parent_id"),
      workorder: this.belongsTo(WorkOrder, "workorder_id"),
      workorder_id: this.attr(null),
      location: this.belongsTo(Location, "location_id"),
      location_id: this.attr(null),
      attachments: this.hasMany(BatchAttachment, "batch_id"),
      composition: this.hasMany(BatchRawOrigin, "batch_id"),
      measurements: this.hasMany(BatchMeasurement, "batch_id"),
      shipments: this.hasMany(ShippingItem, "batch_id")
    };
  }
  static batchCount(projectid) {
    return this.query()
      .where("project", parseInt(projectid))
      .count();
  }
  toCreatePayload() {
    return {
      forgeID: this.forgeID,
      name: this.name,
      coatedquantity: this.coatedquantity,
      coatedcycles: this.coatedcycles,
      picoshield: this.picoshield,
      archived: this.archived,
      units: this.units,
      parent: this.parent_id,
      workorder: this.workorder_id,
      location: this.location_id
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(124) },
        coatedquantity: {
          maxLength: maxLength(13),
          decimal,
          minValue: minValue(0)
        },
        coatedcycles: {
          maxLength: maxLength(6),
          decimal,
          minValue: minValue(0)
        },
        location_id: { required },
        units: { required }
      }
    };
  }
}

